// import React, { useEffect, useState } from "react";
// import UIBody from "../../../components/ui/UIBody";
// import useApiCallHooks from "../../../hooks/useApiCallHooks"; // make sure path is correct
// import { Link } from "react-router-dom";

// const CaseSection = () => {
//   const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
//   const [list, setList] = useState([]);

//   // Initial Fetch
//   useEffect(() => {
//     callAPI("get", "get-case-studies");
//   }, []);

//   // Update list when response changes
//   useEffect(() => {
//     if (responce?.data && statusCode === 200) {
//       setList(responce.data);
//     }
//   }, [responce, statusCode]);

//   return (
//     <section className="py-5 bg-light">
//       <div className="container">
//         {/* Heading */}
//         <div className="text-center mb-5">
//           <h2 className="fw-bold">Featured Case Studies</h2>
//           <p className="text-muted">
//             Discover how we've helped businesses transform their digital
//             presence and achieve remarkable results.
//           </p>
//         </div>

//         {/* Loading State */}
  

//         {/* Case Study Cards */}
//         <div className="row g-4">
//           {list.map((study) => (
//             <div key={study.id} className="col-md-6 col-lg-4">
//               <div className="card h-100 shadow-sm border-0 rounded-4">
//                 <img
//                   src={study.image}
//                   className="card-img-top rounded-top-4"
//                   alt={study.title}
//                   style={{ height: "220px", objectFit: "cover" }}
//                 />
//                 <div className="card-body">
//                   <div className="d-flex align-items-center mb-2">
//                     <span className="badge bg-light text-dark me-2">
//                       {study.category}
//                     </span>
//                     <small className="text-muted">{study.year}</small>
//                   </div>
//                   <h5 className="card-title fw-bold">{study.name}</h5>
//                   <p className="card-text text-muted">{study.description}</p>
//                 </div>
//                  <Link to={`/case-study/details/${study.slug}`}>     
//                <button className="btn w-100 text-white rounded mb-4">View</button>
                 
                 
                 
//                  </Link>
//               </div>
//             </div>
//           ))}

//           {/* Empty state */}
        
//         </div>
//       </div>
//     </section>
//   );
// };

// export default CaseSection;

import React, { useEffect, useState } from "react";
import UIBody from "../../../components/ui/UIBody";
import useApiCallHooks from "../../../hooks/useApiCallHooks"; // make sure path is correct
import { Link } from "react-router-dom";

const CaseSection = () => {
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  const [list, setList] = useState([]);

  // Initial Fetch
  useEffect(() => {
    callAPI("get", "get-case-studies");
  }, []);

  // Update list when response changes
  useEffect(() => {
    if (responce?.data && statusCode === 200) {
      setList(responce.data);
    }
  }, [responce, statusCode]);

  return (
    <section className="py-5 bg-light">
      <div className="container">
        {/* Heading */}
        <div className="text-center mb-5">
          <h2 className="fw-bold">Featured Case Studies</h2>
          <p className="text-muted">
            Discover how we've helped businesses transform their digital
            presence and achieve remarkable results.
          </p>
        </div>

        {/* Case Study Cards */}
        <div className="row g-4">
          {list.map((study) => (
            <div key={study.id} className="col-md-6 col-lg-4">
              <div className="card h-100 shadow-sm border-0 rounded-4">
                <img
                  src={study.image}
                  className="card-img-top rounded-top-4"
                  alt={study.title}
                  style={{ height: "220px", objectFit: "cover" }}
                />
                <div className="card-body">
                  <div className="d-flex align-items-center mb-2">
                    <span className="badge bg-light text-dark me-2">
                      {study.category}
                    </span>
                    <small className="text-muted">{study.year}</small>
                  </div>
                  <h5 className="card-title fw-bold">{study.name}</h5>
                  {/* FIX: Render HTML properly */}
                  {/* <p
                    className="card-text text-muted"
                    dangerouslySetInnerHTML={{ __html: study.description }}
                  ></p> */}
                </div>
                <Link to={`/case-study/details/${study.slug}`}>
                  <button className="btn w-100 text-white rounded mb-4">
                    View
                  </button>
                </Link>
              </div>
            </div>
          ))}

          {/* Empty state */}
          {list.length === 0 && (
            <div className="text-center text-muted">No case studies found.</div>
          )}
        </div>
      </div>
    </section>
  );
};

export default CaseSection;

